import { status } from "skin/event/status";
import act from "./action";
import checkimg from "./data";

const bid = (obj, form, story, data, d, action) => {
	console.log("[Сайт - форма] событие", obj);
	switch (obj.type) {
		case "action":
			return act(obj, form, story, data, d, action);
		case "data":
			return checkimg(obj, form, story, data, d, action);
		default:
			return status.action;
	}
};

export default bid;
